module.exports = __webpack_public_path__ + "img/saldo-tidak-cukup.88f7bc5c.png";